document.addEventListener("DOMContentLoaded", () => {

  const STORAGE_KEY = "tenpalm_wishlist";

  /* -----------------------------
     商品ページ・一覧ページ
  ----------------------------- */

  const buttons = document.querySelectorAll(".wishlist-button");

  buttons.forEach((button) => {

    const heart = button.querySelector(".wishlist-heart");
    const text = button.querySelector(".wishlist-text");

    const product = {
      id: button.dataset.productId,
      variantId: button.dataset.variantId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
    };

    const updateButton = () => {

      const wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      const isFavorite = wishlist.some(item => item.id === product.id);

      button.classList.toggle("active", isFavorite);

      if (heart) {
        heart.textContent = isFavorite ? "♥" : "♡";
      }

      if (text) {
        text.textContent = isFavorite
          ? "お気に入り登録済み"
          : "お気に入り登録";
      }

    };

    updateButton();

    button.addEventListener("click", (e) => {

      e.preventDefault();
      e.stopPropagation();

      let wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

      const index = wishlist.findIndex(item => item.id === product.id);

      if (index > -1) {
        wishlist.splice(index, 1);
      } else {
        wishlist.push(product);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

      updateButton();
      updateWishlistCount();

    });

  });

  /* -----------------------------
     お気に入りページ
  ----------------------------- */

  const grid = document.getElementById("wishlist-grid");

  if (!grid) return;

  const wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

  if (!wishlist.length) {
    grid.innerHTML = "<p>お気に入り商品はまだありません。</p>";
    return;
  }

  grid.innerHTML = "";

  wishlist.forEach(product => {

    grid.innerHTML += `
      <div class="wishlist-item">

        <a href="${product.url}">
          <img src="${product.image}" alt="${product.title}">
        </a>

        <h3>${product.title}</h3>

        <p class="wishlist-price">
          ¥${(Number(product.price) / 100).toLocaleString()}
        </p>

        <div class="wishlist-actions">

          <button
            class="wishlist-cart"
            data-variant-id="${product.variantId}">
            カートに入れる
          </button>

          <button
            class="wishlist-remove"
            data-id="${product.id}">
            削除
          </button>

        </div>

      </div>
    `;

  });

  /* -----------------------------
     カートに入れる
  ----------------------------- */

  document.querySelectorAll(".wishlist-cart").forEach(button => {

    button.addEventListener("click", async () => {

      if (!button.dataset.variantId) {
        alert("この商品は一度お気に入り登録し直してください。");
        return;
      }

      try {

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: button.dataset.variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error("カート追加失敗");
        }

        // Toast表示
        const toast = document.createElement("div");
        toast.className = "wishlist-toast";
        toast.textContent = "✓ カートに追加しました";

        document.body.appendChild(toast);

        requestAnimationFrame(() => {
          toast.classList.add("show");
        });

        setTimeout(() => {
          toast.classList.remove("show");

          setTimeout(() => {
            toast.remove();
          }, 300);

        }, 2500);

        // Broadcastのカートドロワーを開く
        document.body.dispatchEvent(
          new CustomEvent("baseline:cart:afteradditem")
        );

      } catch (e) {

        alert("カートに追加できませんでした。");
        console.error(e);

      }

    });

  });

  /* -----------------------------
     削除
  ----------------------------- */

  document.querySelectorAll(".wishlist-remove").forEach(button => {

    button.addEventListener("click", () => {

      let list = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

      list = list.filter(item => item.id !== button.dataset.id);

      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));

      updateWishlistCount();

      location.reload();

    });

  });
   /* -----------------------------
     ヘッダー件数
  ----------------------------- */

  function updateWishlistCount() {

    const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

    const badges = document.querySelectorAll(".wishlist-count");

    if (!badges.length) return;

    badges.forEach(badge => {
      badge.textContent = list.length;
      badge.classList.toggle("hidden", list.length === 0);
    });

  }

  updateWishlistCount();

});
